import { useTranslation } from 'react-i18next'

import { AccountTiersInfo } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AccountTier = ({ subscriptionPlan, onActiveSubscription }) => {
  const { t } = useTranslation()

  return (
    <Styles.InfoContainer>
      <Styles.InfoTitle>{t('Plan actual')}</Styles.InfoTitle>
      <Styles.AccountTierContainer>
        <AccountTiersInfo type={subscriptionPlan} onActive={onActiveSubscription} />
      </Styles.AccountTierContainer>
    </Styles.InfoContainer>
  )
}

export default AccountTier
